import styled from "styled-components";

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: calc(var(--spacing-3) / 2);
    padding-block: calc(var(--spacing-3) / 2);
    border-top: 1px solid var(--color-grey-4);

    @supports not (padding-block: 0) {
        padding-top: calc(var(--spacing-3) / 2);
        padding-bottom: calc(var(--spacing-3) / 2);
    }

    @supports not (padding-inline-start: 0) {
        & > *:not(:nth-last-child(1)) {
            margin-bottom: calc(var(--spacing-3) / 2);
        }
    }
`;

export const Button = styled.button`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;
